import { applyBubbleCaps } from '../bubble/bubbleCap';
import type { ExplorationVolume, HierarchyNode } from '../../types/exploration';
import { buildExplorationHierarchy, type BuildHierarchyOptions } from './buildExplorationHierarchy';

export function buildCappedExplorationHierarchy(
  volumes: ExplorationVolume[],
  opts: BuildHierarchyOptions,
  overflowPages: Record<string, number> | undefined,
): HierarchyNode {
  const root = buildExplorationHierarchy(volumes, opts);
  applyBubbleCaps(root, 'root', overflowPages);
  return root;
}
